/* TRAKVERO theme JS — vanilla, no dependencies. Uses event delegation so it keeps working
   when sections are re-rendered in the Shopify theme editor. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    const nav = $('.mobile-nav');
    if (!nav) return;
    const open = nav.classList.toggle('is-open');
    t.setAttribute('aria-expanded', String(open));
  });

  /* ---------- Scroll reveal ---------- */
  let io = null;
  function initReveal() {
    const items = $$('.reveal:not(.is-in)');
    const inEditor = window.Shopify && window.Shopify.designMode;
    if (inEditor || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    if (!io) {
      io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.12 });
    }
    items.forEach((el) => io.observe(el));
  }

  /* ---------- Product gallery ---------- */
  function selectSlide(root, key, by) {
    const slides = $$('[data-slide]', root);
    const thumbs = $$('[data-thumb]', root);
    let target = null;
    if (by === 'media') target = slides.find((s) => s.dataset.mediaId === String(key));
    else target = slides.find((s) => s.dataset.slide === String(key));
    if (!target) return;
    slides.forEach((s) => { s.hidden = s !== target; });
    thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.thumb === target.dataset.slide)));
  }

  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      selectSlide(thumb.closest('[data-product-section]') || document, thumb.dataset.thumb, 'index');
      return;
    }
    const step = e.target.closest('[data-qty] [data-step]');
    if (step) {
      const input = $('input', step.closest('[data-qty]'));
      const min = Number(input.min) || 1;
      const max = Number(input.max) || 99;
      input.value = Math.max(min, Math.min(max, (Number(input.value) || 1) + Number(step.dataset.step)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---------- Variant selector: price, stock, buttons, image ---------- */
  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-variant-select]');
    if (!select) return;
    const root = select.closest('[data-product-section]');
    if (!root) return;
    const opt = select.selectedOptions[0];
    const available = opt.dataset.available === 'true';

    $$('[data-price]').forEach((el) => { el.textContent = opt.dataset.price; });
    const compare = $('[data-compare-price]', root);
    if (compare) {
      compare.textContent = opt.dataset.compare || '';
      compare.hidden = !opt.dataset.compare;
    }

    const stock = $('[data-stock]', root);
    if (stock) {
      stock.classList.toggle('stock--in', available);
      stock.classList.toggle('stock--out', !available);
      const txt = $('[data-stock-text]', stock);
      if (txt) txt.textContent = available ? 'In stock' : 'Sold out';
    }
    $$('[data-atc]').forEach((b) => {
      b.disabled = !available;
      const label = $('[data-atc-label]', b);
      if (label) label.textContent = available ? 'Add to cart' : 'Sold out';
    });

    if (opt.dataset.mediaId) selectSlide(root, opt.dataset.mediaId, 'media');

    const url = new URL(window.location.href);
    url.searchParams.set('variant', select.value);
    window.history.replaceState({}, '', url.toString());
  });

  /* ---------- With / Without compare slider ---------- */
  document.addEventListener('input', (e) => {
    const range = e.target.closest('.compare__range');
    if (!range) return;
    const frame = range.closest('[data-compare]');
    if (frame) frame.style.setProperty('--pos', range.value + '%');
  });

  /* ---------- Sticky add-to-cart (appears when the buy box scrolls away) ---------- */
  let stickyObserver = null;
  function initSticky() {
    const sticky = $('.sticky-atc');
    const buybox = $('.buybox');
    if (stickyObserver) { stickyObserver.disconnect(); stickyObserver = null; }
    if (!sticky || !buybox || !('IntersectionObserver' in window)) return;
    stickyObserver = new IntersectionObserver(([en]) => {
      sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
    });
    stickyObserver.observe(buybox);
  }

  function init() { initReveal(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
